export default "__VITE_ASSET__DE6KE5A___"